/**
 * "Show more" on the posts page (home.php): fetches the next page and
 * appends its cards to [data-post-list] instead of navigating. The link is a
 * real next-page URL, so without JS (or on a fetch error) it just navigates.
 */

document.addEventListener( 'click', async ( event ) => {
	const link = event.target.closest( '[data-load-more]' );
	const list = document.querySelector( '[data-post-list]' );
	if ( ! link || ! list ) {
		return;
	}

	event.preventDefault();
	link.setAttribute( 'aria-busy', 'true' );

	try {
		const response = await fetch( link.href, { credentials: 'same-origin' } );
		if ( ! response.ok ) {
			throw new Error( response.statusText );
		}

		const doc = new DOMParser().parseFromString( await response.text(), 'text/html' );
		const items = doc.querySelectorAll( '[data-post-list] > li' );
		list.append( ...items );

		const next = doc.querySelector( '[data-load-more]' );
		if ( next ) {
			link.href = next.href;
			link.removeAttribute( 'aria-busy' );
		} else {
			link.parentElement.remove();
		}
	} catch {
		window.location.href = link.href;
	}
} );
